import Amplify, { API } from "aws-amplify";
import { FETCH_SKILL } from "./types";
import { amplifyConfig } from "../../../src/amplifyConfig";

import {getEnvironmentName} from "../../utils"
const environment = getEnvironmentName()
const config = require("app_configuration").CONFIGURATION[environment];

const API_REQUEST_FIXED_PARAMS = {
  Version: config.RESPONSUM_API_VERSION,
  Api: config.RESPONSUM_API,
  AccountType: config.RESPONSUM_API_RESOURCE_TYPE.PRIVATE
};

export const fetchSkill = () => async (dispatch, getState) => {
  const state = getState();

  let data = {
    queryStringParameters: {
      AccessToken: state.auth.cognitoUser.signInUserSession.accessToken.jwtToken,
      ApiCall: "GetTenantSkill"
    }
  };
  const response = await API.get(config.AWS_API_NAME, "skill", data);

  if (
    response.code !== 500 &&
    response.data &&
    !amplifyConfig.Interactions.bots.hasOwnProperty(response.data.lex_bot_name)
  ) {
    amplifyConfig.Interactions.bots[response.data.lex_bot_name] = {
      name: response.data.lex_bot_name,
      alias: "demo",
      region: config.AWS_REGION,
      providerName: "EVInteractionsProvider"
    };
    Amplify.configure(amplifyConfig);
  }

  dispatch({
    type: FETCH_SKILL,
    payload: response.data
  });
};
